import PropTypes from 'prop-types';
import { useIntl } from 'react-intl';
import PreviewNotice from '../../../../common/PreviewNotice';
import { foundation } from '../../../../../ui';

const { color, fontSize, fontWeight, spacePx } = foundation;

/** KAN-196 — a calm warning line (amber — it blocks subscribing, but it is not an error) when checkout is blocked by an open Stripe bill; "Pay open bill" only with a safe hosted-invoice link. */
export default function UnpaidBalanceNotice({ unpaid, onPay, onDismiss, touch = false }) {
  const intl = useIntl();
  if (!unpaid) return null;
  const btn = (onClick, label, tone, testId) => (
    <button
      type="button"
      onClick={onClick}
      data-testid={testId}
      style={{
        appearance: 'none', background: 'none', border: 0, cursor: 'pointer', font: 'inherit', minHeight: touch ? 44 : undefined,
        fontSize: fontSize.sm, fontWeight: fontWeight.semibold, color: tone === 'primary' ? color.brand.text : color.neutral.textSecondary, padding: `0 ${spacePx[2]}`,
      }}
    >
      {label}
    </button>
  );
  return (
    <div style={{ marginBottom: spacePx[3] }}>
      <PreviewNotice
        tone="warning"
        flush
        isMobile={touch}
        data-testid="unpaid-balance-notice"
        action={unpaid.payUrl
          ? btn(onPay, intl.formatMessage({ id: 'billing.unpaid.pay', defaultMessage: 'Pay open bill' }), 'primary', 'unpaid-balance-pay')
          : btn(onDismiss, intl.formatMessage({ id: 'common.close', defaultMessage: 'Close' }), 'quiet', 'unpaid-balance-dismiss')}
      >
        {intl.formatMessage({ id: 'billing.unpaid.message', defaultMessage: 'You have an unpaid bill. Pay it to subscribe again.' })}
      </PreviewNotice>
    </div>
  );
}

UnpaidBalanceNotice.propTypes = {
  unpaid: PropTypes.shape({ payUrl: PropTypes.string }),
  onPay: PropTypes.func,
  onDismiss: PropTypes.func,
  touch: PropTypes.bool,
};
